import { useMemo } from 'react'
import * as React from 'react'
import gql from 'graphql-tag'
import styled, { css } from 'styled-components'
import { useChannelChildCommentsQuery } from 'generated/graphql'
import NewsItemComment from '..'
import {
  getLastCursor,
  ChannelChildCommentsUpdateQuery,
} from './SubCommentList.module'

gql`
  query channelChildComments(
    $newsItemId: ID!
    $parentId: ID!
    $commentFirst: Int!
    $commentAfter: String
  ) {
    comments(
      newsItemId: $newsItemId
      parentId: $parentId
      first: $commentFirst
      after: $commentAfter
    ) {
      totalCount
      edges {
        ...NewsItemComment_NewsCommentEdge
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`

type TProps = {
  newsItemId: string
  parentId: string
  viewerIsNewsAuthor: boolean
  type?: 'card' | 'modal'
}

const SubCommentList: React.FC<TProps> = ({
  type = 'card',
  newsItemId,
  viewerIsNewsAuthor,
  parentId,
}) => {
  const initialVariables = {
    newsItemId,
    parentId,
    commentFirst: 1,
    commentAfter: undefined,
  }

  // 대댓글 더 불러오기
  const { data, fetchMore } = useChannelChildCommentsQuery({
    variables: initialVariables,
  })

  const cursor = getLastCursor(data?.comments.edges)

  const handleMoreBtn = () => {
    if (!data) return

    const variables = {
      ...initialVariables,
      commentFirst: 10,
      commentAfter: cursor,
    }
    fetchMore({
      variables,
      updateQuery: ChannelChildCommentsUpdateQuery,
    })
  }

  const hasMoreSubComment = useMemo(() => {
    if (data) return data.comments.pageInfo.hasNextPage
    return false
  }, [data])

  return (
    <StyledWrapper type={type}>
      {hasMoreSubComment && (
        <a className="sub-comment-more-btn" onClick={handleMoreBtn}>
          ―― 이전 답글 보기
        </a>
      )}
      <div className="sub-comment-list">
        {data &&
          [...data.comments.edges]
            .reverse()
            .map((comment) => (
              <NewsItemComment
                key={comment.node.id}
                newsItemId={newsItemId}
                viewerIsNewsAuthor={viewerIsNewsAuthor}
                isRootComment={false}
                data={comment}
              />
            ))}
      </div>
    </StyledWrapper>
  )
}

export default SubCommentList

const StyledWrapper = styled.div<{
  type?: 'card' | 'modal'
}>`
  .sub-comment-more-btn {
    display: block;
    margin-left: 52px;
    padding-bottom: 16px;
    font-size: 12px;
    color: #555555;
  }
  .sub-comment-list {
    margin-left: 52px;
  }
  ${({ type }) =>
    type === 'modal' &&
    css`
      .sub-comment-more-btn {
        margin-left: 44px;
      }
      .sub-comment-list {
        margin-left: 44px;
      }
    `}
`
